export const withOpacity = (color, opacity) => {
  const opacityHex = Math.floor((opacity / 100) * 255)
    .toString(16)
    .padStart(2, '0')
  return `${color}${opacityHex}`
}
